import React, { useState, useRef, useEffect } from 'react'
import { getRelativeBasePath } from '../../../global/environments/path'
import Loader from '../../../components/Loading/Loading.jsx'
import InstitutionalUserId from './InstitutionalUserId.jsx'
import InstitutionalMFA from './common/InstitutionalMFA.jsx'
import InstitutionalChangePassword from './common/InstitutionalChangePassword.jsx'
import InstitutionalMFAnswer from './common/InstitutionalMFAnswer.jsx'
import InstitutionalCancelVerification from './common/InstitutionalCancelVerification.jsx'
import {
  generateUID,
  addTMXScriptToBody,
} from '../../utility/threatMetrix/TMX.js'
import {
  screens,
  accessStorage,
  makeForgotPasswordRequest,
  makeChangePasswordRequest,
  errorMessage,
} from './common/institutionalServiceHelper.js'

function InstitutionalForgotPasswordContainter() {
  const [tmxId, setTmxId] = useState()
  const passwordRef = useRef(null)
  const [activeScreen, setActiveScreen] = useState(
    screens.FORGOT_PASSWORD_SCREEN
  )
  const [screenData, setScreenData] = useState({})
  const [isShowLoader, setShowLoader] = useState(false)

  const onCancleClick = () => {
    setActiveScreen(screens.FORGOT_PASSWORD_SCREEN)
  }

  const screenChangeHandler = (screen, data = {}) => {
    setActiveScreen(screen)
    setScreenData((p) => ({ ...p, ...data }))
  }

  const onSuccessFullLogin = () => {
    setActiveScreen(screens.CHANGE_PASSWORD_SCREEN)
    getUserIdForgotPassword()
  }

  // this function is calling when change password scrren is visible
  const getUserIdForgotPassword = async () => {
    setShowLoader(true)
    try {
      const userId = accessStorage.getUserInfo()?.userId
      const data = await makeForgotPasswordRequest(
        { userId },
        {
          action: 'forgotPwd',
        }
      )
      if (data && data?.error) {
        if (data?.error?.details) {
          forgotPasswordHandleError(
            data.error.details.code,
            passwordRef?.current?.showDefaultMessage
          )
        } else {
          forgotPasswordHandleError(
            data?.error?.code,
            passwordRef?.current?.showDefaultMessage
          )
        }
      }
    } catch (error) {
      passwordRef?.current?.showDefaultMessage()
    }
    setShowLoader(false)
  }

  const onSuccessChangePassword = async (payload, handleError) => {
    setShowLoader(true)
    try {
      const data = await makeChangePasswordRequest({
        newPassword: payload?.newPassword,
      })
      if (data && !data.error) {
        window.location.href = getRelativeBasePath() + '/login'
      } else {
        if (data?.error?.details) {
          handleError(data.error.details.code, data.error.details.message)
        } else {
          handleError(data?.error?.code, data.error.message)
        }
      }
    } catch (error) {
      passwordRef?.current?.showDefaultMessage()
    }
    setShowLoader(false)
  }

  const forgotPasswordHandleError = (code, errorFuncton) => {
    switch (code) {
      case '7002-1112':
      case '7002-1114':
        errorFuncton(
          'For your protection, your account has been locked. For assistance, please call Shareholder Services at <a aria-label="800. 3 4 5. 6 6 1 1" href="tel: 8003456611">800.345.6611</a> for assistance.'
        )
        break
      case '7002-3009':
        errorFuncton(
          'We were not able to verify the information you have provided below. Please try again. If you continue to receive this error. Please contact your Relationship Manager'
        )
        break
      default:
        errorFuncton(errorMessage.defaultError)
    }
  }

  const addTMXScriptToBodyHandler = async () => {
    const tmx_id = `cti_ins_${generateUID()}`
    setTmxId(tmx_id)
    await addTMXScriptToBody(tmx_id)
  }

  useEffect(() => {
    addTMXScriptToBodyHandler()
  }, [])

  const _props = {
    ...screenData,
    tmxId,
    screenChangeHandler,
    setShowLoader,
    onCancleClick,
  }

  return (
    <>
      <div className="u-bgColorBrandDark">
        <div className="u-sizeConstrained">
          <h1 className="u-textColorWhite  u-sm-textSizeMsrp4 u-md-textSizeMsrp5 u-paddingVert4gu">
            Forgot Password
          </h1>
        </div>
      </div>
      <div className="u-posRelative u-bgColorLightest u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0 u-padding8gu u-marginBottom10gu">
        {isShowLoader && <Loader />}
        {activeScreen === screens.FORGOT_PASSWORD_SCREEN && (
          <InstitutionalUserId
            {..._props}
            forgotPasswordHandleError={forgotPasswordHandleError}
          />
        )}
        {activeScreen === screens.CANCEL_VERIFICATION_SCREEN && (
          <InstitutionalCancelVerification {..._props} />
        )}
        {activeScreen === screens.MFA_SCREEN && (
          <InstitutionalMFA {..._props} />
        )}
        {activeScreen === screens.MFA_ANSWER_SCREEN && (
          <InstitutionalMFAnswer
            {..._props}
            onSuccessFullLogin={onSuccessFullLogin}
          />
        )}
        {activeScreen === screens.CHANGE_PASSWORD_SCREEN && (
          <InstitutionalChangePassword
            {..._props}
            ref={passwordRef}
            onSuccessChangePassword={onSuccessChangePassword}
            fromForgotPassword={true}
          />
        )}
      </div>
    </>
  )
}
export default InstitutionalForgotPasswordContainter
